import { Vue, Component } from 'vue-property-decorator'
import declOfNum from '~/utils/declOfNum'
import LinkSelector from '~/components/element/LinkSelector'
import LinkItem from '~/types/LinkItem'
import * as count from '~/utils/config/productCount'
import * as sort from '~/utils/config/productSort'
import s from '~/utils/s'

@Component
export default class PopularHeader extends Vue {
  get textProduct (): string {
    return declOfNum(s(this.$store).popularPage.list.count, [
      'товар',
      'товара',
      'товаров'
    ])
  }

  get selectedCount (): string {
    const query = this.$route.query
    return count.checkValue(query.count).toString()
  }

  get selectedSort (): string {
    const query = this.$route.query
    return sort.checkValue(query.sort)
  }

  get countList (): LinkItem[] {
    const query = this.$route.query
    const get = (code: string) => (
      {
        code,
        title: code,
        location: {
          path: this.$route.path,
          query: {
            ...query,
            count: code
          }
        }
      }
    )

    return count.default.map(e => get(e.toString()))
  }

  get sortList (): LinkItem[] {
    const query = this.$route.query
    const get = (sortCode: string, name: string) => (
      {
        code: sortCode,
        title: name,
        location: {
          path: this.$route.path,
          query: {
            ...query,
            sort: sortCode
          }
        }
      }
    )

    return Object.entries(sort.default).map(([k, v]) => get(k, v))
  }

  mounted(){
    s(this.$store).unknownPage.changeShowSticky(true);
  }

  beforeDestroy(){
    s(this.$store).unknownPage.setShowSticky(false)
  }

  render () {
    return (
      <div class="entity-list-header">
        <div class="entity-list-header__content">
          <h1 class="entity-list-header__content-header">
            Популярные товары
          </h1>
          <div class="entity-list-header__content-count">
            {s(this.$store).popularPage.list.count}&nbsp;{this.textProduct}
          </div>
        </div>
        <div class="entity-list-header__sort">
          <div class="entity-list-header__sort-text">Товаров на странице:</div>
          <div class="entity-list-header__sort-count">
            <LinkSelector {...{
              props: {
                items: this.countList,
                selected: this.selectedCount
              }
            }} />
          </div>
          <div class="entity-list-header__sort-product">
            <LinkSelector {...{
              props: {
                items: this.sortList,
                selected: this.selectedSort
              }
            }} />
          </div>
        </div>
        <div class="entity-list-header__filter">
          <div class="entity-list-header__filter-button" onClick={(e: MouseEvent) => {
            e.stopPropagation()
            s(this.$store).general.showPopup('FilterPopup')
          }}>
            Фильтр
          </div>
        </div>
      </div>
    )
  }
}
